"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "comeglians": {
    "837d8970": [{
      "hkey": "828be57f",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "comeglians": [{
      "hkey": "828be57f",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "43eecec1": [{
      "hkey": "b66ae6fc",
      "slug": "comeglians",
      "name": "Comeglians",
      "primary": true,
      "skipSearch": false
    }],
    "noiaretto": [{
      "hkey": "b66ae6fc",
      "slug": "comeglians",
      "name": "Comeglians",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;